import React from "react";
import { isNullOrEmpty } from "../helpers/string-helper";
export const Row = (props) => {
    return React.createElement("div", { className: `ms-Grid-row` + (isNullOrEmpty(props.className) ? '' : ' ' + props.className) }, props.children);
};
